<script setup lang="ts">

import { ref, watch } from 'vue';
import { usePresentation } from '@/modules/Presentation/Types';
import { useLead } from "../../Types/Lead";
import { useForm, Form } from "@library/Components/Forms/Form/v2";
import { LeadOptions } from '../../Types/LeadOptions';
import { Transitions } from '@/modules/Presentation/Transitions';
import { Map } from '../../Types/Map';

import SelectOption from "../../Components/SelectOption.vue";
import EmailTextField from '@library/Components/Forms/EmailTextField/EmailTextField.vue';

const isInterested = ref<boolean|undefined>();
const lead = useLead();
const form = await useForm( lead );
const presentation = usePresentation();

presentation.backgroundImage = '/images/sample/gkr-watermark.png';

watch( isInterested, value => presentation.goto( value == true ? Map.QualifyLead : Map.OfferInformationEmail ) );

</script>

<template>

    <Page>

        <div class="flex flex-col gap-4 w-full text-lg">

            <Form 
                :form="form"
                v-slot="{ model, state }">

                <div class="flex flex-col gap-8 items-center text-xl px-24">

                    <p>
                        Hi! Thanks for stopping by. Just so I can help point you in the right direction — 
                        mind if I ask a couple of quick questions?
                    </p>

                    <SelectOption 
                        v-model="isInterested" 
                        :options="LeadOptions.greeting"   
                        variant="button"            
                    />

                </div>

            </Form>
            
        </div>

    </Page>

</template>